'use client';

import React, { useState } from 'react';

import { Add } from '@depop/web-thrift-ui/Icons/Add';
import { Remove } from '@depop/web-thrift-ui/Icons/Remove';
import { Body, Heading } from '@depop/web-thrift-ui/Typography';

import styles from './styles.module.css';

type AccordionRowProps = {
  title: string;
  content: React.ReactNode;
};

export function AccordionRow({ title, content }: AccordionRowProps) {
  const [isOpen, setIsOpen] = useState(false);

  function handleClick() {
    setIsOpen(!isOpen);
  }

  return (
    <div className={styles.container}>
      <button className={styles.accordionButton} onClick={handleClick}>
        <div>
          {isOpen ? <Remove size="sm" /> : <Add size="sm" border="regular" />}
        </div>
        <Heading variant="sm">{title}</Heading>
      </button>
      {isOpen && (
        <Body as="div" variant="sm-regular" className={styles.content}>
          {content}
        </Body>
      )}
    </div>
  );
}
